import type { FC } from 'react';
import styles from '../styles/step-progress.module.scss';

const StepProgress: FC<{
    steps: readonly string[];
    currentStep: number;
}> = ({ steps, currentStep }) => {
    const stateClassName = (index: number) =>
        index === currentStep
            ? styles.current
            : index <= currentStep
              ? styles.active
              : styles.inactive;

    return (
        <div className={styles.stepProgress}>
            <div className={styles.labels}>
                {steps.map((step, index) => (
                    <span key={step} className={`${styles.label} ${stateClassName(index)}`}>
                        {step}
                    </span>
                ))}
            </div>
            <div className={styles.track}>
                {steps.map((step, index) => (
                    <div key={`${step}-track`} className={styles.trackItem}>
                        <span className={`${styles.circle} ${stateClassName(index)}`} />
                        {index < steps.length - 1 && (
                            <span
                                className={`${styles.line} ${index < currentStep ? styles.active : styles.inactive}`}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StepProgress;
